import Immutable from 'seamless-immutable';
import _ from 'lodash';
import FormModel from './form-model';
import { baseCollection } from '../../common/collections';

/**
 * Takes an array of form objects and turns each object into a Model and the array into a Collection of the models
 * Doesn't work with array of already created Models
 * Most commonly used in a selector when reading an array of forms from the redux state tree and you want to turn them into a Collection
 * @param {Array} forms - an array of plain forms to wrap into a FormCollection
 */
function create(forms = []) {
  return Immutable(_.map(forms, FormModel.create));
}

/**
 * Transforms and array of backend form objects into a FormCollection
 * @param {Object[]} forms - backend formatted forms
 * @returns {Form[]}
 */
function deserialize(forms = []) {
  return Immutable(_.map(forms, FormModel.deserialize));
}

/**
 * Transforms a FormCollection into an array of backend form objects
 * @param {Form[]} forms
 * @returns {Object[]}
 */
function serialize(forms) {
  return _.map(forms, form => FormModel.serialize(form));
}

export default {
  ...baseCollection,
  create,
  deserialize,
  serialize,
};
